import { Fragment, useState } from 'react';
import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { Button, DialogFooter } from '@pocketlaw/tetris';
import { useFormikContext } from 'formik';
import { EsigningRecipientType } from 'shared/domains/apollo/generated/types';
import { CancelButton, SubmitButton } from 'shared/domains/forms';
import { NewContact } from '../../ContactLibrary/NewContact';
export function Footer(props) {
    const { isEdit, onClose, setTabId } = props;
    const [newContact, setNewContact] = useState(false);
    const { setValues } = useFormikContext();
    const submitLabel = isEdit
        ? t({ message: 'Save party', comment: 'Label for edit eSigning party dialog save button' })
        : t({ message: 'Add party', comment: 'Label for add eSigning party dialog save button' });
    const handleUseNewContact = (values) => {
        var _a, _b, _c, _d, _e, _f, _g;
        setValues({
            email: (_a = values.email) !== null && _a !== void 0 ? _a : '',
            firstName: (_b = values.firstName) !== null && _b !== void 0 ? _b : '',
            lastName: (_c = values.lastName) !== null && _c !== void 0 ? _c : '',
            label: (_d = values.label) !== null && _d !== void 0 ? _d : '',
            mobile: (_e = values.mobile) !== null && _e !== void 0 ? _e : '',
            title: (_f = values.title) !== null && _f !== void 0 ? _f : '',
            type: EsigningRecipientType.Signatory,
            authenticationMode: (_g = values.authenticationMode) !== null && _g !== void 0 ? _g : undefined,
        });
        setNewContact(false);
        setTabId('form');
    };
    return (<Fragment>
      {newContact && <NewContact onClose={() => setNewContact(false)} onSuccess={handleUseNewContact}/>}
      <DialogFooter description={<Button type="button" size="small" appearance="secondary" onClick={() => setNewContact(true)}>
            <Trans comment="Label for creating new contact in add eSigning party modal">New contact</Trans>
          </Button>}>
        <CancelButton onClick={onClose} size="small">
          <Trans comment="Label for closing add eSigning party modal">Close</Trans>
        </CancelButton>
        <SubmitButton size="small">{submitLabel}</SubmitButton>
      </DialogFooter>
    </Fragment>);
}
